import { auth } from '../../../../js/app/auth';
import { showingPaywall, getOuterHeight } from '../../../../js/functions';

export default function () {
  const loginBtns = document.querySelectorAll('.login-btn, .bh-btn');
  loginBtns.forEach((btn) => {
    const { redirectUrl, loginUrl } = auth;
    if (!redirectUrl || !loginUrl) {
      return;
    }
    btn.addEventListener('click', (evt) => {
      evt.preventDefault();

      fetch(`${redirectUrl}?op=saveref`, { method: 'GET' })
        .then(() => {
          window.location.href = btn.getAttribute('href');
        })
        .catch((err) => {
          console.log(err);
        });
    });
  });

  if (showingPaywall) {
    const paywall = document.querySelector('.paywall');

    const { previousSibling } = paywall.previousSibling;
    if (previousSibling !== undefined && previousSibling.classList.contains('article-text')) {
      document.documentElement.style.setProperty('--paywall-gradient-height', `${getOuterHeight(previousSibling)}px`);
      document.documentElement.style.setProperty('--paywall-gradient-height-reverse', `${getOuterHeight(previousSibling) * -1}px`);
    }
  }
}
